import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4db17848"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "post"
}
const _hoisted_2 = {
  key: 0,
  class: "post-title"
}
const _hoisted_3 = {
  key: 1,
  class: "post-title"
}
const _hoisted_4 = {
  key: 2,
  class: "post-date"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No post found.", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.post)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.post.post_is_public)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.post.post_title), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.post.post_title) + " (PRIVATE)", 1)
            ])),
        (_ctx.post.post_date)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.post.post_date.toLocaleString("en-GB")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "post-content",
          innerHTML: _ctx.sanitizedContent
        }, null, 8, _hoisted_5)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
}